import { Image, type ImageProps } from 'antd';
import type { StyleHTMLAttributes } from 'react';
import IMAGES from '../assets/images';
type Props = {
  height?: number | string;
  width?: number | string;
  size?: number;
  src: string;
  placeholder?: string;
  preview?: boolean;
  style?: StyleHTMLAttributes<'div'>;
} & ImageProps;

const CustomImage: React.FC<Props> = ({
  src,
  placeholder = IMAGES.placeholder,
  height = 200,
  width = 200,
  size = undefined,
  preview = false,
  style,
  ...rest
}) => {
  return (
    <Image
      width={size || width}
      height={size || height}
      preview={preview}
      src={src || placeholder}
      style={{
        maxWidth: '100%',
        maxHeight: '100%',
        ...style,
      }}
      onError={(e) => {
        (e.currentTarget as HTMLImageElement).src = placeholder;
      }}
      {...rest}
    />
  );
};

export default CustomImage;
